import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/home-run
// A home run occurs when a batter hits a fair ball and scores on the play without being put out or without the benefit of an error.
const classifiesAsHomeRun = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsHomeRun;